import {Component} from 'react'

import './index.css'

export default function Footer() {
  return (
    <footer className="footer-div">
      <div className="footer-tasty-kitchens-div">
        <img
          className="footer-img-logo"
          src="https://res.cloudinary.com/dzpzhwjgy/image/upload/v1637848185/Frame_275_tkhq3w.png"
        />
        <p>Tasty Kitchens</p>
      </div>

      <p className="footer-para">
        The only thing we are serious about is food. Contact us on
      </p>
      <ul className="footer-ul">
        <li>
          <img
            className="footer-img-logo"
            src="https://res.cloudinary.com/dzpzhwjgy/image/upload/v1637848945/App_Logo_Inspiraton_111_mamrw0.jpg"
          />
        </li>
        <li>
          <img
            className="footer-img-logo"
            src="https://res.cloudinary.com/dzpzhwjgy/image/upload/v1637848945/instagram_hh7jjh.png"
          />
        </li>
        <li>
          <img
            className="footer-img-logo"
            src="https://res.cloudinary.com/dzpzhwjgy/image/upload/v1637848946/path3611_uzczfj.png"
          />
        </li>
        <li>
          <img
            className="footer-img-logo"
            src="https://res.cloudinary.com/dzpzhwjgy/image/upload/v1637848945/App_Logo_Inspiraton_42_piv9vr.png"
          />
        </li>
      </ul>
    </footer>
  )
}
